import React, { useEffect } from 'react';
import PropTypes from 'prop-types';

import style from './RemoteOralExam.scss';
import QuestionDisplayContainer from '../question/QuestionDisplay';
import NotesInput from './NotesInput';
import settingsReader from '../../store/readHelpers/SettingsReader';
import remoteOralExamService from '../../services/RemoteOralExamService';
import RemoteOralExamConstants from '../../constants/RemoteOralExamConstants';

const Topic = ({ questionId }) => {
    const onQuestionReady = () => {};

    if (questionId) {
        useEffect(() => {
            remoteOralExamService.sendDisplayStatusAcknowledge(RemoteOralExamConstants.contextDisplayStatus.CONTEXT_DISPLAY_ACK);
            return () => {
                remoteOralExamService.sendDisplayStatusAcknowledge(RemoteOralExamConstants.contextDisplayStatus.CONTEXT_HIDE_ACK);
            };
        }, []);
    }

    return (<div className={style.topicContainer}>
        { questionId &&
            <QuestionDisplayContainer
                contentRevisionId={questionId}
                onReady={onQuestionReady}
            />
        }

        {settingsReader.allowCandidateTakeNotesDuringRemoteOralExam() && <NotesInput />}
    </div>);
};

Topic.propTypes = {
    questionId: PropTypes.number,
};

export default Topic;
